/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { houseOffblack } from "../assets/house-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconHouseOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={houseOffblack.svg} />
);

IllustrativeIconHouseOffblack.displayName = "IllustrativeIconHouseOffblack";
